import React from "react";
import { Typography } from "@RHCommerceDev/unstyled-ui-components";
import getAbsoluteUrl from "utils/getAbsoluteUrl";
import { useLocalization } from "hooks/useLocalization";
import { cn } from "utils/cn";
import LocationIcon from "@RHCommerceDev/icon-header-location";
import { GALLERY_LOCATOR } from "@RHCommerceDev/resources/rh-header.json";
import { usePageContent } from "customProviders/LocationProvider";
import useLocale from "@RHCommerceDev/hooks/useLocale";

const Galleries = () => {
  const { pageContent } = usePageContent();
  const locale = useLocalization();
  const pageContentData = pageContent?.globalHeader as Record<string, string>;

  const splitLocale = useLocale();
  const isFrenchCanada = splitLocale === "fr-CA";

  return (
    <a
      data-analytics-galleries="galleries-link"
      href={getAbsoluteUrl("/store-locations/stores.jsp", locale)}
      className="flex items-center gap-1 text-inherit no-underline"
      aria-label={pageContentData?.GALLERY_LOCATOR ?? GALLERY_LOCATOR}
    >
      <Typography
        variant="caption"
        fontFamily="rhc"
        fontWeight="thin"
        className={cn(
          "mt-0.5 hidden text-[13px] uppercase leading-[1.2em] tracking-[0.04em] sm:block lg:text-[15px]",
          { "md:text-[11px] lg:text-[13px] xl:text-[15px]": isFrenchCanada }
        )}
      >
        {pageContentData?.GALLERIES}
      </Typography>
      <div
        className={cn(
          "flex items-center justify-center",
          "h-[22px] w-[22px] sm:h-[26px] sm:w-[26px]"
        )}
      >
        <LocationIcon className="h-4.25 w-[12.364px]" />
      </div>
    </a>
  );
};

export default Galleries;
